<template>
    <div :class="{ 'ah-audit-flow-viewer': true, small: size == 'small', left: align == 'left' }" v-if="items">
        <div class="audit-step first default">
            <div class="step-block no-tail-arrow">
                <div class="name">申請</div>
                <span class="to-next-arraw" />
            </div>
        </div>
        <div :class="{ 'audit-step': true }" v-for="(item, index) in flowItemsWithOutADD" :key="index">
            <div class="step-block">
                <div class="name">
                    <span v-if="item.menU_UNT == 'A02'">{{ a02Text }}</span>
                    <span v-else-if="item.menU_UNT == 'A03'">{{ a03Text }}</span>
                    <span v-else-if="item.menU_UNT == 'B02'">{{ b02Text }}</span>
                    <span v-else-if="item.menU_UNT == 'B03'">{{ b03Text }}</span>
                    <span v-else-if="item.menU_UNT == '主管'">主管</span>
                    <span v-else>{{ item.menU_UNT }}</span>
                </div>
                <span class="to-next-arraw" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ah-audit-flow-editor',
    props: {
        items: {
            type: Array,
            default: null,
        },
        size: {
            type: String,
            default: 'normal',
        },
        align: {
            type: String,
            default: 'center',
        },
        a02Text: {
            type: String,
            default: '填寫付款明細',
        },
        a03Text: {
            type: String,
            default: '確認付款',
        },
        b02Text: {
            type: String,
            default: '開立',
        },
        b03Text: {
            type: String,
            default: '入帳',
        },
    },
    components: {},
    data() {
        return {};
    },
    watch: {},
    computed: {
        flowItemsWithOutADD() {
            if (this.items) return this.items.filter((e) => e.menU_UNT != 'ADD');
            return [];
        },
    },
    created() {},
    methods: {},
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.ah-audit-flow-viewer {
    $default-bg-color: #cad1f1;
    $custom-bg-color: #cad1f1;

    text-align: center;

    &.left {
        text-align: left;
    }

    .audit-step {
        display: inline-block;
        position: relative;
        margin: 0px 25px 0 0px;
        vertical-align: top;
        min-width: 50px;

        .step-block {
            position: relative;
            background-color: $default-bg-color;
            padding: 0px 5px;
            height: 60px;

            // 預設項目的名稱
            .name {
                line-height: 60px;
                padding: 0 25px;
                font-weight: bold;
            }

            // 箭頭裝飾
            .to-next-arraw {
                position: absolute;
                display: block;
                top: 0px;
                right: -15px;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 30px 0 30px 15px;
                border-color: transparent transparent transparent $default-bg-color;
            }

            &:before {
                position: absolute;
                top: 0px;
                left: -15px;
                content: "";
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 0px 15px 30px 0px;
                border-color: transparent $default-bg-color transparent transparent;
            }

            &:after {
                position: absolute;
                bottom: 0px;
                left: -15px;
                content: "";
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 0px 0 30px 15px;
                border-color: transparent transparent $default-bg-color transparent;
            }

            &.no-tail-arrow {
                &:after,
                &:before {
                    display: none;
                }
            }
        }

        &.first {
            .step-block {
                border-top-left-radius: 15px;
                border-bottom-left-radius: 15px;
            }
        }

        &:last-child {
            .step-block {
                border-top-right-radius: 15px;
                border-bottom-right-radius: 15px;
            }

            .to-next-arraw {
                display: none;
            }
        }

        // 預設項目顏色
        &.default {
            .step-block {
                background-color: $default-bg-color;

                &:before {
                    border-color: transparent $default-bg-color transparent transparent;
                }

                &:after {
                    border-color: transparent transparent $default-bg-color transparent;
                }

                .to-next-arraw {
                    border-color: transparent transparent transparent $default-bg-color;
                }
            }
        }
    }

    &.small {
        .step-block {
            height: 30px;
            margin: 0px -10px 0 0px;

            .name {
                line-height: 30px;
                padding: 0 10px;
                font-size: 9pt;
            }

            .to-next-arraw {
                top: 0px;
                right: -7px;
                border-width: 15px 0 15px 7px;
            }

            &:before {
                top: 0px;
                left: -7px;
                border-width: 0px 7px 15px 0px;
            }

            &:after {
                bottom: 0px;
                left: -7px;
                border-width: 0px 0 15px 7px;
            }
        }
    }
}
</style>
